/**
 * ルート進入前の先回りモーダルの文言: 画像動画ルート。
 * 見た目は既存の動画の先回りシート（MediaPointShortagePrompt）で、見出し・導入・注記だけ差し替える。
 */
export const preroutePromptMedia = {
  /** 見出しの上の導入（既存の「他の動画を見る」シートと同じ。2026-10-08 ユーザー指定） */
  lead: "まだ見ていない",
  /** 見出し（既存の「他の動画を見る」シートと同じ。画像は語だけ差し替え） */
  titleVideo: "あなただけに届いた動画",
  titleImage: "あなただけに届いた画像",
  /** CTA: 先頭（止まったときの対象）の購入確認へ進む */
  cta: "開封して見る",
  /** CTA 下の注記: 値段と、いまの手持ちで開ける数 */
  noteVideo: (args: { point: string | number; count: string | number }) =>
    `動画 ${args.point}pt（手持ちで ${args.count} 本）`,
  noteImage: (args: { point: string | number; count: string | number }) =>
    `画像 ${args.point}pt（手持ちで ${args.count} 枚）`,
  thumbAltVideo: (args: { name: string | number }) => `${args.name}さんの動画`,
  thumbAltImage: (args: { name: string | number }) => `${args.name}さんの画像`,
  age: (args: { age: string | number }) => `${args.age}歳`,
  listLabelVideo: "届いている未開封の動画",
  listLabelImage: "届いている未開封の画像",
  openList: "一覧で見る",
  close: "閉じる",
} as const;
